<template>
  <div>
    <ul class="operate-account">
      <li v-for="item in reporterOperators" :key="item.columnId" @click="shareNFNum(item.columnId)">
        <div class="info">
          <img :src="item.columnIcon||require('../mainPage/images/default_header.png')" alt="">
          <div class="info-con">
            <h3>{{item.columnName}}</h3>
            <p>{{item.columnDescription}}</p>
          </div>
        </div>
        <button class="btn-book btn-opacity">+订阅</button>
      </li>
    </ul>
    <nf-toast 
      v-model="toastOptions.showTost"
      :toastTxt="toastOptions.toastTxt">
    </nf-toast>
  </div>
</template>


<script>
import http from '@common/js/tools/http.js'
import config from '../../../config'
import utils from '@common/utils'

const NET_ERR_MSG = '网络连接超时，请稍后重试'
export default {
  name: 'operateAccount',
  data() {
    return {
      reporterOperators:[],
      // 显示toast
      toastOptions: {
        showTost: false,
        toastTxt: ''
      },
      // 记者信息
      reporterInfo: {}
    }
  },
  created() {
    document.title = '南方号'
    this.getReporterInfoList()
  },
  methods: {
    // 根据记者id获取记者作品集
    // 获取记者信息
    getReporterInfoList(showLoading) {
      let url = `nanfang_if/reporter/list?reporterUuid=${
        this.$route.query.reporterUuid
      }&pageSize=10&pageNo=1&origin=1`
      let pageLoadingDom = document.getElementById('page-loading')
      if (!pageLoadingDom && showLoading) {
        this.showLoading = true
      }
      if (!this.$route.query.reporterUuid || this.$route.query.reporterUuid == '0') {
        window.location.href = process.env.VUE_APP_404_PAPE
        return
      }
      http
        .get(url, {})
        .then(res => {
          if (pageLoadingDom) {
            pageLoadingDom.parentNode.removeChild(pageLoadingDom)
          }
          showLoading && (this.showLoading = false)
          if (res.data && res.code === 200) {
            if(!res.data.reportInfo || !res.data.reportInfo.reporterUuid){
              window.location.href = process.env.VUE_APP_404_PAPE
              return
            }
            this.reporterOperators = res.data.reportInfo.reporterOperators
            // 存储记者信息
            Object.assign(this.reporterInfo, res.data.reportInfo)
            // 初始化微信分享
            this.initWxShare()
          } else {
            this.showToast(res.msg)
          }
        })
        .catch(err => {
          if (pageLoadingDom) {
            pageLoadingDom.parentNode.removeChild(pageLoadingDom)
          }
          showLoading && (this.showLoading = false)
          window.console.warn(err)
          this.showToast(NET_ERR_MSG)
        })
    },
    // 点击订阅跳转对应页面
    shareNFNum (id) {
      window.location.href = `${config.shareNFNum}?nfhId=${id}`
    },
    // toast提示
    showToast(msg = '') {
      this.toastOptions.toastTxt = msg
      this.toastOptions.showTost = true
    },
    // 下面是复制过来，后续再用vuex将请求api和请求方法和其他公用方法提取出来@TODO
    // 初始化微信分享
    initWxShare() {
      const isWx = utils.getSystemInfo().isWx
      if (!isWx) return
      let _buryingPoint = this.buryingPoint
      let shareOptions = {}
      shareOptions.title = `${this.reporterInfo.reporterName}作品集-南方Plus`
      shareOptions.desc = `${this.reporterInfo.reporterName}，${
        this.reporterInfo.reporterDescribe
      }。`
      shareOptions.link = `${config.openAppUrl}?reporterUuid=${
        this.reporterInfo.reporterUuid
      }&isOutside=1`
      shareOptions.imgUrl = this.reporterInfo.reporterPortraitUrl
      shareOptions.success = function() {
        // 进行埋点
        _buryingPoint(this.shareType)
      }
      utils.initWxShare(shareOptions)
    },
    // 分享埋点
    buryingPoint(shareType, params) {
      let buryingPointOptions = {
        deviceid: utils.getDevicedId(),
        dataType: '1000073',
        reporterUuid: this.reporterInfo.reporterUuid || '',
        origin: '2'
      }
      if (shareType) {
        buryingPointOptions.shareChanel = shareType
      }
      Object.assign(buryingPointOptions, params)
      return new Promise(resolve => {
        http
          .get(config.buryingPointUrl, buryingPointOptions)
          .then(() => {
            resolve(true)
          })
          .catch(err => {
            window.console.error(err)
            resolve(false)
          })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  html, body{
    height: auto;
  }
  @mixin center-block {
    display: flex;
    align-items: center;
  }
  .operate-account {
    padding: 0 .3rem;
    li {
      @include center-block;
      justify-content: space-between;
      padding: .3rem 0;
      border-bottom: .01rem solid #EEEEEE;
      .info {
        @include center-block;
      }
      img {
        width: .8rem;
        height: .8rem;
        border-radius: 50%;
        border: .01rem solid #EEEEEE;
        margin-right: .2rem;
      }
      .info-con {
        h3 {
          width: 4.6rem;
          line-height: .48rem;
          font-family: PingFangSC-Regular;
          font-size: .34rem;
          font-weight: normal;
          color: #333333;
          letter-spacing: 0;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        p {
          width: 4.6rem;
          line-height: .37rem;
          font-family: PingFangSC-Regular;
          font-size: .26rem;
          color: #999999;
          letter-spacing: 0;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .btn-book {
        padding: .06rem .12rem;
        font-family: PingFang-SC-Medium;
        font-size: .24rem;
        color: #F64E45;
        letter-spacing: 0;
        border: 1px solid #F64E45;
        border-radius: .1rem;
        &.btn-opacity {
          &:active {
            background-color: rgba(255, 255, 255, 0.2);
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
  }
</style>

